export default __webpack_public_path__ + "static/bg-innovation-0213a52f360702dabce91fc48923fde8.jpg";